interface DataConfig {
  key: string;
  graph: string;
  transform: (data: any, fullData?: any) => any;
}

export const userAnalyticsDataConfigs: DataConfig[] = [
  {
    key: 'users_overview.total_users',
    graph: 'MetricCard',
    transform: (data: any) => ({
      title: 'Total Users',
      value: data?.toString() || '0',
      change: 'Total Application Users',
      changeType: 'positive',
      icon: 'PeopleIcon',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      accentColor: '#667eea'
    })
  },
  {
    key: 'users_overview.new_users',
    graph: 'MetricCard',
    transform: (data: any) => ({
      title: 'New Users',
      value: data?.toString() || '0',
      change: 'New Users This Month',
      changeType: 'positive',
      icon: 'TrendingUpIcon',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      accentColor: '#4facfe'
    })
  },
  {
    key: 'average_group_size.total_groups',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Total Groups',
      value: data?.toString() || '0',
      change: `Avg Size: ${fullData.average_group_size?.average_size || 0}`,
      changeType: 'positive',
      icon: 'AccessTimeIcon',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      accentColor: '#f093fb'
    })
  },
  {
    key: 'top_chat_users',
    graph: 'DonutChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      name: item.participant_name,
      user_id: item.participant_id,
      value: item.value,
      color: item.color
    })) || []
  },
  {
    key: 'top_groups',
    graph: 'DonutChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      name: item.group_name,
      group_id: item.group_id,
      value: item.value,
      color: item.color
    })) || []
  },
  {
    key: 'average_group_size.average_size',
    graph: 'MetricCard',
    transform: (data: any) => ({
      title: 'Average Group Size',
      value: data?.toString() || '0',
      change: 'Average number of participants per group',
      changeType: 'positive',
      icon: 'PeopleIcon',
      gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      accentColor: '#fa709a'
    })
  },
  {
    key: 'new_users_by_date',
    graph: 'BarChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      name: item.date,
      count: item.count,
      date: item.date
    })) || []
  },
  {
    key: 'online_users_heatmap',
    graph: 'HeatMap',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      hour: item.hour,
      value: item.value
    })) || []
  },
  {
    key: 'online_frequency_distribution',
    graph: 'BarChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      name: item.interval,
      value: item.user_count
    })) || []
  },
  {
    key: 'online_users_per_day',
    graph: 'LineChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      name: item.date,
      users: item.unique_users_count,
      events: item.total_online_events
    })) || []
  },
  {
    key: 'active_group_count',
    graph: 'LineChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      name: item.date,
      groups: item.active_groups
    })) || []
  },
  {
    key: 'top_groups_by_participants',
    graph: 'BarChart',
    transform: (data: any) => data?.groups?.map((group: any) => ({
      group_id: group.group_id,
      name: group.group_name,
      participants: group.participants_count
    })) || []
  }
];